import type { MarketingProcess } from '../../types/shared';

export const CAMPAIGN_NAME_FILTER: Record<MarketingProcess, string> = {
  'testing': 'CP-Test-Campaign-Template',
  'scaling': 'Scale-Campaign-template',
  'scaling_eg': 'Evergreen',
  'inbox': 'inbox',
  'hypothesis_testing': 'CP-Test-Campaign-Template',
};

export const SINGLE_AD_TYPE = 'single_ad';